import React from 'react';
import { Coffee } from 'lucide-react';
const LOADING_CITIES = [{
  code: 'BLR',
  name: 'Bangalore'
}, {
  code: 'VZG',
  name: 'Vizag'
}, {
  code: 'BOM',
  name: 'Mumbai'
}];
// Retro luggage-tag stripe palette (top band of the live ticket)
const STRIPES = ['#E0533D', '#E7A93B', '#3FA796', '#2E4A62'];
export function CityStripe() {
  return <>
      {/* Desktop: a stack of vintage boarding-pass / luggage tags on the right edge */}
      <aside className="hidden lg:flex fixed right-4 top-1/2 -translate-y-1/2 z-20 flex-col items-center gap-3 pointer-events-none select-none" aria-label="Kraya is live in Hyderabad; more cities coming soon" data-id="element-22">
        {/* Live ticket — Hyderabad */}
        <div className="w-20 rounded-2xl border-4 border-black bg-[#FBF3DD] neo-shadow overflow-hidden flex flex-col items-center" data-id="element-23">
          {/* Retro stripe band */}
          <div className="flex w-full h-3" data-id="element-24">
            {STRIPES.map(c => <div key={c} className="flex-1" style={{
            backgroundColor: c
          }} data-id="element-25" />)}
          </div>

          {/* Punch hole */}
          <div className="mt-3 w-4 h-4 rounded-full border-2 border-black bg-kraya-yellow" data-id="element-26" />

          {/* Vertical city name */}
          <div className="py-4" data-id="element-27">
            <span className="font-bold text-xl tracking-[0.25em] uppercase" style={{
            writingMode: 'vertical-rl',
            transform: 'rotate(180deg)'
          }} data-id="element-28">
              Hyderabad
            </span>
          </div>

          <Coffee className="w-5 h-5 mb-2" aria-hidden="true" data-id="element-29" />

          {/* Perforation */}
          <div className="w-full border-t-4 border-dashed border-black/40" data-id="element-30" />

          {/* Live status */}
          <div className="w-full bg-black py-2 flex flex-col items-center gap-1" data-id="element-31">
            <span className="relative flex h-2.5 w-2.5" data-id="element-32">
              <span className="absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75 animate-ping" data-id="element-33" />
              <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-green-400 border border-black" data-id="element-34" />
            </span>
            <span className="text-kraya-yellow font-bold text-[10px] tracking-[0.2em] uppercase" data-id="element-35">
              Live
            </span>
          </div>
        </div>

        {/* Loading tags — other cities */}
        {LOADING_CITIES.map(city => <div key={city.code} className="w-14 rounded-xl border-4 border-dashed border-black/40 bg-[#FBF3DD]/70 py-3 flex flex-col items-center gap-1" title={`${city.name} — coming soon`} data-id="element-36">
            <span className="font-bold text-sm tracking-widest text-black/60" data-id="element-37">
              {city.code}
            </span>
            <span className="text-[8px] font-bold uppercase tracking-[0.15em] text-black/40" data-id="element-38">
              Soon
            </span>
          </div>)}
      </aside>

      {/* Mobile: a compact ticket-style pill near the top-left */}
      <div className="lg:hidden fixed top-3 left-3 z-20 pointer-events-none select-none" data-id="element-39">
        <span className="inline-flex items-center gap-1.5 bg-[#FBF3DD] text-black font-bold text-xs uppercase tracking-wide pl-2 pr-3 py-1.5 rounded-full border-2 border-black neo-shadow" data-id="element-40">
          <span className="flex h-4 items-center gap-0.5" data-id="element-41">
            {STRIPES.map(c => <span key={c} className="w-1 h-4 rounded-sm" style={{
            backgroundColor: c
          }} data-id="element-42" />)}
          </span>
          <span className="relative flex h-2.5 w-2.5" data-id="element-43">
            <span className="absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75 animate-ping" data-id="element-44" />
            <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-green-400" data-id="element-45" />
          </span>
          Live in Hyderabad
        </span>
      </div>
    </>;
}